import React, { PropsWithChildren, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import Bullet from '@/components/Bullet';
import { AppText } from '@/components/AppText';
import { BulletItem } from '@/types/BulletItem';

const styles = StyleSheet.create({
  wrapper: {
    gap: 20,
  },
  row: {
    flexDirection: "row",
    gap: 10,
    alignItems: "flex-start",
  },
  normal: {
  },
  bold: {
    fontWeight: "bold",    
  },
});

interface Props {
  data: BulletItem[],
  bulletStart?: number,
};

export function BulletList({
  data,
  bulletStart = 0,
}: Props) : React.ReactNode {
  return (
    <View style={styles.wrapper}>
      {data.map((value: BulletItem, index: number) => (
        <View key={"bullet" + index} style={styles.row}>
          <Bullet id={bulletStart + (index + 1)} />
          <AppText style={(value.bold ?? false) ? styles.bold : styles.normal}>{value.content}</AppText>
        </View>
      ))}
    </View>
  );
};
